import classNames from 'classnames/bind';
import { LocalStorageKeys } from 'constants/localStorageKeys';
import TrackingEvent, { TrackingProperty } from 'constants/trackingEvents';
import { H4 } from 'koba/components/Typography';
import { useTranslation } from 'react-i18next';
import { routes } from 'utils/routerHelpers';

import React from 'react';

import { Notification } from '@thinkific/toga-react';

import { useCommunityContext } from 'components/CommunityContext';
import withDismissable from 'components/HOCs/Dismissable';
import { InjectedDismissableProps } from 'components/HOCs/Dismissable/Dismissable';

import styles from './EmailNotificationUpsell.module.scss';

const cx = classNames.bind(styles);

const EmailNotificationUpsell: React.FC<InjectedDismissableProps> = ({ onDismiss }) => {
  const { t } = useTranslation();
  const { trackEvent } = useCommunityContext();

  const onClick = (event) => {
    event.preventDefault();
    trackEvent(TrackingEvent.CLICK_UPGRADE_SUBSCRIPTION_LINK, {
      [TrackingProperty.COMPONENT]: 'EmailNotificationUpsell',
    });
    window.open(routes.subscription, '_blank');
  };

  return (
    <div className={cx('email-notification-upsell', 'mb-2')} data-qa="email-notification-upsell">
      <Notification type="upsell" hasCloseButton onClose={onDismiss}>
        <H4>
          {t(
            'components-emailNotificationUpsell-header',
            'Increase your event attendance with notifications and RSVPs:'
          )}
        </H4>
        <div>
          <ul>
            <li>
              {t(
                'components-emailNotificationUpsell-first_bullet',
                'Notify your community members about upcoming events with email invites'
              )}
            </li>
            <li>
              {t('components-emailNotificationUpsell-second_bullet', 'Track RSVPs to your events')}
            </li>
          </ul>
        </div>
        <div>
          <a href={routes.subscription} target="_blank" onClick={onClick}>
            {t(
              'components-emailNotificationUpsell-upgrade_to_unlock',
              'Upgrade to unlock event email notifications and RSVPs'
            )}
          </a>
        </div>
      </Notification>
    </div>
  );
};

export const EventFormEmailNotificationUpsell = withDismissable(
  EmailNotificationUpsell,
  LocalStorageKeys.eventFormEmailNotificationUpsell
);
export const EventsPageEmailNotificationUpsell = withDismissable(
  EmailNotificationUpsell,
  LocalStorageKeys.eventsPageEmailNotificationUpsell
);

export default EmailNotificationUpsell;
